<template>
  <div class="sperrzeit-datum-feld">
    <FeldLabel v-if="label" :icon="calendarIcon" :text="label" :optional="optional" :status="status" />
    <AppDatePicker
      :value="value"
      value-type="YYYY-MM-DD"
      placeholder="Datum wählen"
      :min="min"
      :max="max"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import { Calendar } from 'lucide-vue';
import FeldLabel from '@/components/common/feld-label.vue';
import AppDatePicker from '@/components/common/app-date-picker/app-date-picker.vue';

export default {
  name: 'SperrzeitDatumFeldComponent',
  components: {
    FeldLabel,
    AppDatePicker,
  },
  props: {
    value: { type: String, default: null },
    label: { type: String, default: null },
    optional: { type: Boolean, default: false },
    status: { type: String, default: null },
    min: { type: [String, Date], default: null },
    max: { type: [String, Date], default: null },
  },
  computed: {
    calendarIcon() {
      return Calendar;
    },
  },
};
</script>

<style scoped>
.sperrzeit-datum-feld {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
}
</style>
